(function () {
  const STATUS_ESTIMATE_KEY = {
    'always-pre-order': 'eddPreorder',
    'pre-order': 'eddPreorder',
    'ready-to-ship': 'eddReadyToShip',
    'made-to-order': 'eddMadeToOrder'
  };

  class CroBadge extends HTMLElement {
    constructor() {
      super();
      this.initialized = false;
      this.observer = new IntersectionObserver(this.handleIntersect.bind(this), { threshold: 0.1 });
      this.observer.observe(this);
    }

    handleIntersect(entries, observer) {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.connectedCallback();
          observer.disconnect();
        }
      });
    }

    connectedCallback() {
      if (this.initialized || !window.EddEstimate) return;
      this.initialized = true;

      this.cacheDOMElements();
      this.initVariants();
      this.calculateEstimate();

      const form = document.querySelector(`#${this.dataset.productFormId}`);
      if (form) {
        form.addEventListener('variant:changed', this.debounce(this.onVariantChange.bind(this), 300));
      }
    }

    cacheDOMElements() {
      this.deliveryTextElement = this.querySelector('.js-cro-delivery-text');
      this.deliveryItem = this.querySelector('.js-cro-delivery');
      this.deliveryInput = this.querySelector('.js-cro-badge-input');
    }

    initVariants() {
      const { variants, variant, rtsFormat, rtsPrefix, mtoFormat, mtoPrefix, settingsJson } = this.dataset;

      this.calendar = window.EddEstimate.create(window.EddEstimate.decode(settingsJson));
      this.variantStates = window.EddEstimate.decode(variants, []);
      this.variant = window.EddEstimate.decode(variant);
      this.readyToShipDisplay = { format: rtsFormat || 'date', prefix: rtsPrefix || 'Delivery by' };
      this.madeToOrderDisplay = { format: mtoFormat || 'date', prefix: mtoPrefix || 'Made to order · Delivery by' };
    }

    debounce(func, wait) {
      let timeout;
      return function (...args) {
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(this, args), wait);
      };
    }

    onVariantChange(e) {
      const { variant } = e.detail;
      this.variant = variant;
      this.calculateEstimate();
    }

    variantState() {
      const variantState = this.variantStates.find((e) => e.id === this.variant.id);

      if (!variantState || variantState.label === 'sold-out' || !this.variant.available) {
        return { label: 'sold-out' };
      }

      const key = STATUS_ESTIMATE_KEY[variantState.label];
      if (!key || !variantState[key]) {
        return { label: 'fallback' };
      }

      // A pre-order is quoted from the restock date; everything else from today. The cut-off bump
      // applies either way, matching how this has always been projected.
      const start = variantState.label === 'pre-order' && variantState.nextIncomingDate
        ? new Date(variantState.nextIncomingDate + 'T00:00:00.000Z')
        : this.calendar.today;

      const range = this.calendar.dateRange(variantState[key], { start });
      if (!range) {
        return { label: 'fallback' };
      }

      return { label: variantState.label, ...range };
    }

    calculateEstimate() {
      const variantState = this.variantState();

      if (!this.deliveryTextElement || !this.deliveryItem) return;

      if (variantState.label === 'sold-out' || variantState.label === 'fallback') {
        this.deliveryItem.style.display = 'none';
        this.setAttribute('data-variant-status', variantState.label);
        this.updateDeliveryInput('');
      } else {
        this.deliveryItem.style.display = '';
        this.removeAttribute('data-variant-status');

        const { minDate, maxDate } = variantState;
        const { format, prefix } = variantState.label === 'made-to-order' ? this.madeToOrderDisplay : this.readyToShipDisplay;

        this.deliveryTextElement.textContent = `${prefix} ${this.calendar.format(format, minDate, maxDate)}`;
        this.updateDeliveryInput(this.calendar.format('date', minDate, maxDate));
      }
    }

    updateDeliveryInput(value) {
      if (!this.deliveryInput) return;

      if (value) {
        this.deliveryInput.name = 'properties[Estimated Delivery]';
        this.deliveryInput.value = value;
      } else {
        this.deliveryInput.name = '';
        this.deliveryInput.value = '';
      }
    }
  }

  if ('customElements' in window) {
    customElements.define('cro-badge', CroBadge);
  }
})();
